import { Injectable, inject } from '@angular/core'
import { PermissionService } from '@core/services/permission-service/permission-service'
import { PERMISSIONS } from '@core/constants/permissions.constants'
import { CLIENT_TYPE_GROUPS } from '../constants/client-type.constants'

@Injectable({
    providedIn: 'root',
})
export class ClientPermissionsService {
    private permissionService = inject(PermissionService)

    async getAllowedClientTypeIds(): Promise<number[]> {
        try {
            const permissions = await this.permissionService.getPermissionsBitwise()
            const enabledPermissionNames = permissions
                .filter((permission) => permission.isEnabled)
                .map((permission) => permission.permissionName)

            const allowedIds = new Set<number>()

            if (enabledPermissionNames.includes(PERMISSIONS.ADD_NEW_CLIENT)) {
                CLIENT_TYPE_GROUPS.SCHOOL_TYPES.forEach((id) => allowedIds.add(id))
            }

            if (enabledPermissionNames.includes(PERMISSIONS.CREATE_CLIENT_SHIKSHA)) {
                CLIENT_TYPE_GROUPS.SHIKSHA_TYPES.forEach((id) => allowedIds.add(id))
            }

            return Array.from(allowedIds)
        } catch (error) {
            return []
        }
    }
}
